import React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styled from 'styled-components';
import moment from 'moment';
import { useGetAssetsQuery, useDeleteAssetMutation } from '../../../../features/addassets/addassetApiSlice'
import { TableContStyle, TableHeadStyle } from '../../../../Styles/TableStyles'


const StyledButton = styled.button`
width: 70px;
height: 40px;
padding: 5px 7px;
border: none;
border-radius:10px ;
cursor: pointer;
background-color: teal;
`
const NoDataSpan = styled.span`
width:100%;
font-size:20px;
font-weight:300;
margin-left: 20px ;
`
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomPaginationActionsTable({ handleEditclick }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selected, setSelected] = React.useState('name');

  const {
    data: assets,
    isLoading,
    isSuccess,
    isError,
    error
  } = useGetAssetsQuery('assetlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const [deleteAsset, { isLoading: deleteAssetloading }] = useDeleteAssetMutation()

  let tempdata = assets ? Object.values(assets?.entities) : []

  let tabledata = tempdata.filter(elm => elm.addstatus === 'draft')

  let rows = tabledata || []

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeleteButton = async (Id) => {
    try {
      let body = { id: Id }
      await deleteAsset(body)
      return alert('draft deleted')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }
console.log(rows)
console.log(page)
console.log(rowsPerPage)


  return (
    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      {rows.length === 0 && <NoDataSpan> No drafts are saved  </NoDataSpan>}
      <Table aria-label="custom pagination table">
        <TableHead>
          <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor }}>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">SLNo</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Asset Name</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Order No.</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Model No.</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">OEM/Brand</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Quantity</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Unit Cost</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Purchase Date</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Edit</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row, index) => (
            < TableRow key={index} >
              <TableCell style={{ width: 5 }} component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {row?.name}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {row?.orderno}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {row?.model_no}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {row?.oem}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {row?.quantity}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {row?.unit_price}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                {moment(row.purchase_date).format('DD/MM/YY')}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                <StyledButton onClick={(e) => handleEditclick(e, 'clicked', row._id)}>Draft</StyledButton>
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
                <StyledButton onClick={() => handleDeleteButton(row._id)} >Delete</StyledButton>
              </TableCell>
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 5 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={8}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer >
  );
}
